import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { AuthData } from "auth/AuthWarpper";
import { nav } from "./navigation";
import NotFound from "components/NotFound";
import { CircularProgress } from "@mui/material";

export const RenderRoutes = () => {
  const { user } = AuthData();
  const navigate = useNavigate();
  const [test, setTest] = useState(true);

  // useEffect(() => {
  //   // If user is not authenticated, redirect to login page
  //   console.log('useree' ,user)
  //   if (!user) {
  //     navigate("/login");
  //   }
  // }, []);

  // if (!user || !user.isAuthenticated) {
  //   return null; // or some loading indicator if needed
  // }

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    // If not logged in, redirect to login
    if (!isLoggedIn) {
      navigate("/inactivity");
    } else {
      // setIsLoading(false);
    }
  }, [navigate]);

  const hasPermission = (permission) => {
      // return true
  
    if (
      permission == "Dashboard" ||
      permission == "Login" ||
      permission == "Re Login" ||
      permission == "Role Creation" ||
      permission == "User Creation" ||
      permission == "Export" ||
      permission == "User Delegation" ||
      permission == "Role Delegation" ||
      permission == "Access Management" ||
      permission == "Role Navigation" ||
      permission == "Report" || 
      permission == "Conflict Indicator"||
      permission == "Administrator Creation"
    ) {
      return true;
    } else {
      // return true
      return user?.functionalities?.includes(permission);
    }
  };

  return (
    <Routes>
      {nav.map((r, i) => (
        // (<Route key={i} path={r.path} element={r.element} />)
        <>
         <Route key={i} path={r.path} element={r.element} />
          {/* {hasPermission(r.name) == true ? (
            <Route key={i} path={r.path} element={r.element} />
          ) : (
            <>not found</>
          )} */}
        </>
      ))}
      <Route
        key="222"
        path="*"
        element={
          user ? (
            <NotFound />
          ) : (
            <div>
              <CircularProgress position={"center"} size={20} />
            </div>
          )
        }
      />
    </Routes>
  );
};
